import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);

// Connect to Firebase emulators when explicitly enabled
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';
const useLocalFunctions = process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true';

if (
  typeof window !== 'undefined' &&
  (useEmulators || useLocalFunctions) &&
  (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  ) &&
  process.env.NODE_ENV === 'development'
) {
  try {
    if (useEmulators) {
      // Full emulator mode - all services local
      // Auth Emulator
      connectAuthEmulator(auth, 'http://localhost:9098', { disableWarnings: true });

      // Firestore Emulator
      connectFirestoreEmulator(db, 'localhost', 8081);

      // Functions Emulator (us-central1 region)
      connectFunctionsEmulator(functions, 'localhost', 5002);

      // Storage Emulator (optional; safe if storage not used)
      connectStorageEmulator(storage, 'localhost', 9199);
      // eslint-disable-next-line no-console
      console.info('[Firebase] Connected to ALL local emulators');
    } else if (useLocalFunctions) {
      // Local functions only - Auth and Firestore use production
      // Functions Emulator (us-central1 region)
      connectFunctionsEmulator(functions, 'localhost', 5002);
      // eslint-disable-next-line no-console
      console.info('[Firebase] Connected to local Functions emulator only (Auth & Firestore use production)');
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[Firebase] Failed to connect to emulators:', e);
  }
} else if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.info('[Firebase] Using production Firebase services (emulators disabled)');
}

export default app;
